// import "./AudioComp.css"
import React, { useEffect } from "react"
import Style from './audionew.module.scss'
import SriGif from "../../../../../assets/theme6/Siri.gif"
function AudioNew({ audio }) {
  useEffect(() => {
    function enableAutoplay() {
      document.querySelector("audio").play();
    }
    enableAutoplay()
  }, [])
  return (


    <div className={Style.video_camp} >
      <div className={Style.video_container}>
        <div className={Style.gif_wrapper}>
          <img
            src={SriGif}
            alt="music"
            className={Style.music_gif}
          />
        </div>
        <audio id='audio' src={audio} autoplay controls style={{ display: 'none' }}></audio>
      </div>
    </div>





  )
}
export default AudioNew